module.exports = __webpack_public_path__ + "img/attention-empty.a33b4623.png";